"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createFromIconfont;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("./index"));

var customCache = new Set();

function createFromIconfont(scriptUrl) {
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */
  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    var type = props.type;
    var content;

    if (type) {
      content = /*#__PURE__*/_react["default"].createElement("use", {
        xlinkHref: "#".concat(type)
      });
    } // fix https://github.com/ZhongAnTech/zarm/issues/835
    // @ts-ignore


    var I = _index["default"]["default"] ? _index["default"]["default"] : _index["default"];
    return /*#__PURE__*/_react["default"].createElement(I, (0, _extends2["default"])({}, props, {
      ref: ref
    }), content);
  });

  return Iconfont;
}